import { useContext, useEffect } from 'react';

import {
  Grid,
  Typography,
  Paper
} from '@material-ui/core';
import GroupIcon from '@material-ui/icons/Group';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import EmojiFoodBeverageIcon from '@material-ui/icons/EmojiFoodBeverage';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import ReceiptIcon from '@material-ui/icons/Receipt';
import RestaurantIcon from '@material-ui/icons/Restaurant';
import CallMissedOutgoingIcon from '@material-ui/icons/CallMissedOutgoing';
import { useHistory } from 'react-router-dom';

import { useStyles } from './main.styles';
import { has } from '../../services/summarize.service';
import { SessionContext } from '../../context/session.context';

export const MainComponent = () => {

  const history = useHistory();
  const classes = useStyles();
  const { logged } = useContext(SessionContext);

  const redirect = (route) => {
    history.push(route);
  }

  useEffect(() => {
    if (!logged) {
      redirect('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container justifyContent="center">
      <Grid item xs={10}>
        <Grid container justifyContent="center" spacing={2}>
          {has('USERS::LIST') && (
            <Grid item xs={12} md={4} lg={2} onClick={() => redirect('/users')}>
              <Paper elevation={2} className={classes.menuItem}>
                <Grid container direction="column" justifyContent="center" alignItems="center" spacing={2}>
                  <Grid item>
                    <GroupIcon fontSize="large" />
                  </Grid>
                  <Grid item>
                    <Typography variant="h4" align="center">
                      Usuarios
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          )}
          {has('CATEGORIES::LIST') && (
            <Grid item xs={12} md={4} lg={2} onClick={() => redirect('/categories')}>
              <Paper elevation={2} className={classes.menuItem}>
                <Grid container direction="column" justifyContent="center" alignItems="center" spacing={2}>
                  <Grid item>
                    <LocalOfferIcon fontSize="large" />
                  </Grid>
                  <Grid item>
                    <Typography variant="h4" align="center">
                      Categorias
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          )}
          {has('PRODUCTS::LIST') && (
            <Grid item xs={12} md={4} lg={2} onClick={() => redirect('/products')}>
              <Paper elevation={2} className={classes.menuItem}>
                <Grid container direction="column" justifyContent="center" alignItems="center" spacing={2}>
                  <Grid item>
                    <EmojiFoodBeverageIcon fontSize="large" />
                  </Grid>
                  <Grid item>
                    <Typography variant="h4" align="center">
                      Productos
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          )}
          {has('SALES::LIST') && (
            <Grid item xs={12} md={4} lg={2} onClick={() => redirect('/sales')}>
              <Paper elevation={2} className={classes.menuItem}>
                <Grid container direction="column" justifyContent="center" alignItems="center" spacing={2}>
                  <Grid item>
                    <MonetizationOnIcon fontSize="large" />
                  </Grid>
                  <Grid item>
                    <Typography variant="h4" align="center">
                      Ventas
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          )}
          {has('CUTOFF::LIST') && (
            <Grid item xs={12} md={4} lg={2} onClick={() => redirect('/cutoff')}>
              <Paper elevation={2} className={classes.menuItem}>
                <Grid container direction="column" justifyContent="center" alignItems="center" spacing={2}>
                  <Grid item>
                    <ReceiptIcon fontSize="large" />
                  </Grid>
                  <Grid item>
                    <Typography variant="h4" align="center">
                      Corte
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          )}
          {has('EXPENSES::LIST') && (
            <Grid item xs={12} md={4} lg={2} onClick={() => redirect('/expenses')}>
              <Paper elevation={2} className={classes.menuItem}>
                <Grid container direction="column" justifyContent="center" alignItems="center" spacing={2}>
                  <Grid item>
                    <CallMissedOutgoingIcon fontSize="large" />
                  </Grid>
                  <Grid item>
                    <Typography variant="h4" align="center">
                      Gastos
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          )}
          <Grid item xs={12} md={4} lg={2} onClick={() => redirect('/carta')}>
            <Paper elevation={2} className={classes.menuItem}>
              <Grid container direction="column" justifyContent="center" alignItems="center" spacing={2}>
                <Grid item>
                  <RestaurantIcon fontSize="large" />
                </Grid>
                <Grid item>
                  <Typography variant="h4" align="center">
                    Carta
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}